<template>
  <div class="hzc-industry-dynamics">
    <!-- 面包屑 -->
    <div v-if="routerInfo.length > 0">
      当前位置：
      <template v-for="(item, index) in routerInfo">
        <span
          @click="back(item.path, index)"
          :key="item.name + '1'"
          :style="{
            cursor: routerInfo.length - 1 === index ? 'auto' : 'pointer',
          }"
          >{{ item.name }}</span
        >
        <span :key="item.name + '2'" v-if="routerInfo.length - 1 !== index"> > </span>
      </template>
    </div>
    <!-- 内容 -->
    <div class="content" v-if="row.id">
      <div class="top">
        <p>{{ row.titleName || row.fileTitle}}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络"}}</span>
      </div>
      <!-- pdf -->
      <div v-if="url" class="bom">
        <PdfLoad :url="url" class="detail-pdf" />
      </div>
      <!-- png -->
      <div v-if="imgUrl" class="bom">
        <img :src="imgUrl" alt="">
      </div>
      <div v-if="row.newsContent" class="bom" v-html="row.newsContent"></div>
    </div>
  </div>
</template>

<script>
import PdfLoad from "@/components/pdfLoad/index.vue";
import request from '@/utils/request'
import { setPageRouter } from "@/utils/pageRouter";

export default {
  components: { PdfLoad },
  data() {
    return {
      routerInfo: [],
      row: {},
      url: "",
      imgUrl: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { url, id, routerInfo } = setPageRouter();
      if (!url) return;
      this.routerInfo = routerInfo || [];
      request({
        url: `${url}/${id}/1`,
        method: 'get'
      }).then(res => {
        this.row = res.data;
        const url = res.data.pdfUrl ? res.data.pdfUrl : res.data.fileUrl || "";
        if (!url) return;
        if (url.indexOf('.pdf') !== -1) {
          this.url = url;
        } else if ( url.indexOf('.png') !== -1) {
          this.imgUrl = url;
        } else {
          window.openUrl(url);
        }
      })
    },
    /**
     * 回退
     */
    back(path, index) {
      if (this.routerInfo.length - 1 !== index) {
        this.$router.push(path || "/index");
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../style/twoPage";
.hzc-industry-dynamics {
  .content {
    width: 960px;
    min-height: 700px;
    height: calc(100vh - 278px);
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin:16px auto 0;
    display: flex;
    flex-direction: column;
    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }
      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }
    .bom {
      flex: 1;
      padding: 16px 16px 16px 0;
      overflow: hidden;
      img {
        max-width: 100%;
      }
      .detail-pdf {
        height: 100%;
      }
    }
  }
}
</style>
